import * as React from 'react';
import { Container } from 'react-bootstrap';

import './styles/section-header.css';
import { HeaderText } from './header-text';

export const SectionHeader = ({section}) => {
    return (
        <div className='section-header'>
            <Container>
                <HeaderText color={'#fff'} text={section} />                
            </Container>
        </div>
    )
}